import 'process/browser';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { LocalizeProvider } from 'react-localize-redux'
import App from './App'
import Store from './core/store/store'

(window as any).process = { ...(window as any).process, browser: true };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <LocalizeProvider store={Store}>
        <BrowserRouter>
          <App/>
        </BrowserRouter>
      </LocalizeProvider>
    </Provider>
  </React.StrictMode>
)
